import { DEFAULT_RANGE } from "../constants/epicLeaderboard";
import type { RangeOption } from "../constants/epicLeaderboard";

export type PlayerTab = "overview" | "pk" | "epics" | "gquests";

export const PLAYER_TABS: { value: PlayerTab; label: string }[] = [
  { value: "overview", label: "Overview" },
  { value: "pk", label: "PK" },
  { value: "epics", label: "Epics" },
  { value: "gquests", label: "GQs" }
];

export const DEFAULT_TAB: PlayerTab = "overview";

export const parseTab = (value: string | null): PlayerTab =>
  PLAYER_TABS.find((t) => t.value === value)?.value ?? DEFAULT_TAB;

type Options = {
  player: string;
  range?: RangeOption;
  tab?: PlayerTab;
  vs?: string | null;
  feedPage?: number;
};

// Query string for a player page link; defaults (all-time range, overview tab,
// page 1) are omitted so URLs stay short.
export const playerSearch = ({
  player,
  range,
  tab,
  vs,
  feedPage
}: Options): string => {
  const params = new URLSearchParams({ player });
  if (range && range !== DEFAULT_RANGE) params.set("range", range);
  if (tab && tab !== DEFAULT_TAB) params.set("tab", tab);
  if (vs) params.set("vs", vs);
  if (feedPage && feedPage > 1) params.set("feedPage", String(feedPage));
  return params.toString();
};

export const playerPath = (options: Options): string =>
  `/player?${playerSearch(options)}`;
